import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getLinks () {
  apiConsolelog('api: getLinks()')

  return request({
    url: '/other-links/list',
    method: 'get'
  })
}
